var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "role"
  }, [_c('div', {
    staticClass: "animated fadeIn"
  }, [_c('div', {
    staticClass: "col-md-12 mb-2"
  }, [_c('b-card', [_c('div', {
    slot: "header"
  }, [_c('b', [_vm._v(" Add NTS Shipment")])]), _vm._v(" "), _c('div', {
    staticClass: "card-body1"
  }, [_c('div', {
    staticClass: "choice-change",
    on: {
      "change": function($event) {
        _vm.selectOption($event)
      }
    }
  }, [_c('div', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.takeActionname),
      expression: "takeActionname"
    }],
    attrs: {
      "type": "radio",
      "id": "shippingId",
      "name": "choice",
      "value": "1"
    },
    domProps: {
      "checked": _vm._q(_vm.takeActionname, "1")
    },
    on: {
      "__c": function($event) {
        _vm.takeActionname = "1"
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "shippingId"
    }
  }, [_vm._v("Shipping Id")])]), _vm._v(" "), _c('div', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.takeActionname),
      expression: "takeActionname"
    }],
    attrs: {
      "type": "radio",
      "id": "bagNo",
      "name": "choice",
      "value": "2"
    },
    domProps: {
      "checked": _vm._q(_vm.takeActionname, "2")
    },
    on: {
      "__c": function($event) {
        _vm.takeActionname = "2"
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "bagNo"
    }
  }, [_vm._v("Bag no. ")])])]), _vm._v(" "), (!_vm.bagVisible) ? _c('form', [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": "AWB Number :",
      "description": ""
    }
  }, [_c('span', {
    staticStyle: {
      "font-size": "11px"
    }
  }, [_vm._v("\n                      (Note: Use Comma(,) for Multiple AWB Numbers)")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-book'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.awbnumber),
      expression: "awbnumber"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "awbnumber",
      "name": "awbnumber",
      "type": "text"
    },
    domProps: {
      "value": (_vm.awbnumber)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.awbnumber = $event.target.value
      }
    }
  }), _vm._v(" "), _c('b-input-group-button', {
    slot: "right"
  }, [_c('b-button', {
    staticClass: "btn btn-secondary",
    on: {
      "click": function($event) {
        _vm.getAWBDetails()
      }
    }
  }, [_vm._v("Go "), _c('i', {
    staticClass: "fa fa-arrow-right",
    attrs: {
      "aria-hidden": "true"
    }
  })])], 1)], 1)], 1)], 1)]), _vm._v(" "), (_vm.shipmentsForBulk.length > 0) ? _c('table', {
    staticClass: "table-bordered table-hover tbl datatables shipmentTable"
  }, [_c('thead', [_c('tr', {
    staticClass: "text-primary"
  }, [_c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Shipping ID")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Current Hub Name")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Destination Hub Name")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Origin Hub Name")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Message")])])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.shipmentsForBulk), function(data) {
    return _c('tr', [_c('td', {
      class: (data.code != 200) ? 'text-danger' : ''
    }, [_vm._v(_vm._s(data.shippingId))]), _vm._v(" "), _c('td', {
      class: (data.code != 200) ? 'text-danger' : ''
    }, [_vm._v(_vm._s(data.currentHubName))]), _vm._v(" "), _c('td', {
      class: (data.code != 200) ? 'text-danger' : ''
    }, [_vm._v(_vm._s(data.destinationHubName))]), _vm._v(" "), _c('td', {
      class: (data.code != 200) ? 'text-danger' : ''
    }, [_vm._v(_vm._s(data.originHubName))]), _vm._v(" "), _c('td', {
      class: (data.code != 200) ? 'text-danger' : ''
    }, [_vm._v(_vm._s((data.code != 200) ? data.message : "-"))])])
  }))]) : _vm._e(), _vm._v(" "), (_vm.resultArray.length > 0) ? _c('table', {
    staticClass: "table-bordered table-hover tbl datatables resultTables"
  }, [_c('thead', [_c('tr', {
    staticClass: "text-primary"
  }, [_c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Shipping ID")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Status")])])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.resultArray), function(data) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(data.ShippingID))]), _vm._v(" "), _c('td', [_vm._v(_vm._s((data.ReturnCode == 100) ? 'NTS marked successfully' : data.ReturnMessage))])])
  }))]) : _vm._e(), _vm._v(" "), (_vm.shipmentsForBulk.length > 0) ? _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('label', [_vm._v("Description:")]), _c('font', {
    attrs: {
      "color": "red"
    }
  }, [_vm._v("*")]), _vm._v(" "), _c('b-input-group', [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.alldata.description),
      expression: "alldata.description"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "description",
      "name": "description",
      "rows": "3"
    },
    domProps: {
      "value": (_vm.alldata.description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.alldata.description = $event.target.value
      }
    }
  })])], 1)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "card-footer"
  }, [_c('button', {
    staticClass: "btn btn-sm btn-success",
    attrs: {
      "disabled": _vm.submitDisable,
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.markBagAsNTS(_vm.shipmentsForBulk)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-floppy-o"
  }), _vm._v(" Submit")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-sm btn-danger",
    attrs: {
      "type": "reset"
    },
    on: {
      "click": function($event) {
        _vm.resetForm()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh"
  }), _vm._v("\n                  Reset")])])]) : _vm._e(), _vm._v(" "), (_vm.bagVisible) ? _c('form', [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": "Bag Number :",
      "description": ""
    }
  }, [_c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-suitcase'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.bagNumber),
      expression: "bagNumber"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "bagNumber",
      "name": "bagNumber",
      "type": "text"
    },
    domProps: {
      "value": (_vm.bagNumber)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.bagNumber = $event.target.value
      }
    }
  }), _vm._v(" "), _c('b-input-group-button', {
    slot: "right"
  }, [_c('b-button', {
    staticClass: "btn btn-secondary",
    on: {
      "click": function($event) {
        _vm.fetchAWBfromBag()
      }
    }
  }, [_vm._v("Go "), _c('i', {
    staticClass: "fa fa-arrow-right",
    attrs: {
      "aria-hidden": "true"
    }
  })])], 1)], 1)], 1), _vm._v(" "), (_vm.shipmentsFromBag.length > 0) ? _c('table', {
    staticClass: "table-bordered table-hover tbl datatables shipmentTable"
  }, [_c('thead', [_c('tr', {
    staticClass: "text-primary"
  }, [_c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Shipping ID")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Current Hub Name")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Destination Hub Name")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Origin Hub Name")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Message")])])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.shipmentsFromBag), function(data) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(data.shippingId))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.currentHubName))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.destinationHubName))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.originHubName))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.message))])])
  }))]) : _vm._e(), _vm._v(" "), (_vm.resultArray.length > 0) ? _c('table', {
    staticClass: "table-bordered table-hover tbl datatables resultTables"
  }, [_c('thead', [_c('tr', {
    staticClass: "text-primary"
  }, [_c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Shipping ID")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Status")])])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.resultArray), function(data) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(data.ShippingID))]), _vm._v(" "), _c('td', [_vm._v(_vm._s((data.ReturnCode == 100) ? 'NTS marked successfully' : data.ReturnMessage))])])
  }))]) : _vm._e()], 1)]), _vm._v(" "), (_vm.shipmentsFromBag.length > 0) ? _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('label', [_vm._v("Description:")]), _c('font', {
    attrs: {
      "color": "red"
    }
  }, [_vm._v("*")]), _vm._v(" "), _c('b-input-group', [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.alldata.description),
      expression: "alldata.description"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "description",
      "name": "description",
      "rows": "3"
    },
    domProps: {
      "value": (_vm.alldata.description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.alldata.description = $event.target.value
      }
    }
  })])], 1)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "card-footer"
  }, [_c('button', {
    staticClass: "btn btn-sm btn-success",
    attrs: {
      "disabled": _vm.submitBagDisable,
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.markBagAsNTS(_vm.shipmentsFromBag)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-floppy-o"
  }), _vm._v(" Submit Shipment")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-sm btn-danger",
    attrs: {
      "type": "reset"
    },
    on: {
      "click": function($event) {
        _vm.resetForm()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh"
  }), _vm._v("\n                  Reset")])])]) : _vm._e()])])], 1)]), _vm._v(" "), _c('vue-element-loading', {
    attrs: {
      "active": _vm.show,
      "duration": "0.6",
      "spinner": "bar-fade-scale",
      "color": "#FF6700"
    }
  })], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-fd0c53ac","hasScoped":true}!./src/views/components/AddNTSShipment/AddNTSShipment.component.html
// module id = 547
// module chunks = 1